import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLungs,
  faQuestionCircle,
  faMapMarkerAlt,
  faPhone,
  faClock,
} from "@fortawesome/free-solid-svg-icons";

const Faq = () => {
  return (
    <div className="faq-page">
      <section className="faq-hero">
        <div className="faq-overlay"></div>
        <div className="container">
          <div className="faq-hero-content">
            <h1>Întrebări frecvente</h1>
            <p>
              Găsiți răspunsuri la cele mai comune întrebări despre serviciile
              noastre
            </p>
          </div>
        </div>
      </section>

      <section className="faq-main section">
        <div className="container">
          <div className="faq-intro text-center mb-5">
            <h2>Cum vă putem ajuta?</h2>
            <p className="lead">
              Am compilat o listă de întrebări frecvente pentru a vă ajuta să
              găsiți informațiile de care aveți nevoie. Dacă nu găsiți răspunsul
              căutat, nu ezitați să ne contactați direct.
            </p>
          </div>

          <div className="faq-categories mb-4">
            <div className="row">
              <div className="col-md-3 col-6 mb-3">
                <a href="#general" className="faq-category-item">
                  <FontAwesomeIcon
                    icon={faQuestionCircle}
                    className="category-icon"
                  />
                  <span>General</span>
                </a>
              </div>
              <div className="col-md-3 col-6 mb-3">
                <a href="#location" className="faq-category-item">
                  <FontAwesomeIcon
                    icon={faMapMarkerAlt}
                    className="category-icon"
                  />
                  <span>Locație</span>
                </a>
              </div>
              <div className="col-md-3 col-6 mb-3">
                <a href="#services" className="faq-category-item">
                  <FontAwesomeIcon icon={faLungs} className="category-icon" />
                  <span>Servicii</span>
                </a>
              </div>
              <div className="col-md-3 col-6 mb-3">
                <a href="#appointments" className="faq-category-item">
                  <FontAwesomeIcon icon={faClock} className="category-icon" />
                  <span>Programări</span>
                </a>
              </div>
            </div>
          </div>

          <div className="faq-accordion-wrapper">
            <div className="faq-category" id="general">
              <h3 className="faq-category-title">
                <FontAwesomeIcon icon={faQuestionCircle} /> Informații generale
              </h3>
              <div className="accordion" id="accordionGeneral">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="generalHeadingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#generalCollapseOne"
                      aria-expanded="true"
                      aria-controls="generalCollapseOne"
                    >
                      <span>Acceptați bilete de trimitere?</span>
                    </button>
                  </h2>
                  <div
                    id="generalCollapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="generalHeadingOne"
                    data-bs-parent="#accordionGeneral"
                  >
                    <div className="accordion-body">
                      <p>
                        Bineînțeles! Cu excepția fisei auto, toate serviciile
                        noastre se pot deconta prin CASMB.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="generalHeadingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#generalCollapseTwo"
                      aria-expanded="false"
                      aria-controls="generalCollapseTwo"
                    >
                      <span>Ce acte sunt necesare pentru o consultație?</span>
                    </button>
                  </h2>
                  <div
                    id="generalCollapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="generalHeadingTwo"
                    data-bs-parent="#accordionGeneral"
                  >
                    <div className="accordion-body">
                      <p>
                        Pentru o consultație la clinica noastră, aveți nevoie
                        de:
                      </p>
                      <ul className="faq-list">
                        <li>Card de sănătate</li>
                        <li>Carte de identitate</li>
                        <li>
                          Bilet de trimitere (dacă doriți decontare prin CASMB)
                        </li>
                        <li>
                          Rezultate anterioare și documente medicale relevante
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="faq-category" id="location">
              <h3 className="faq-category-title">
                <FontAwesomeIcon icon={faMapMarkerAlt} /> Locație și program
              </h3>
              <div className="accordion" id="accordionLocation">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="locationHeadingOne">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#locationCollapseOne"
                      aria-expanded="false"
                      aria-controls="locationCollapseOne"
                    >
                      <span>Cum ajung la clinica dumneavoastră?</span>
                    </button>
                  </h2>
                  <div
                    id="locationCollapseOne"
                    className="accordion-collapse collapse"
                    aria-labelledby="locationHeadingOne"
                    data-bs-parent="#accordionLocation"
                  >
                    <div className="accordion-body">
                      <p>
                        Sunt numeroase mijloace de transport cu care puteți
                        ajunge la clinica noastră.
                      </p>
                      <p>
                        Cel mai facil mijloc de transport în apropierea clinicii
                        este stația de metrou Eroilor, aflată pe magistralele
                        M1, M3, M5. În zonă se regăsesc stații pentru autobuzele
                        336, 123, 226, 696, troleibuzele 61 și 62.
                      </p>
                      <p>
                        Ca punct de reper, clinica se găsește pe străduțele din
                        spatele spitalului Universitar.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="locationHeadingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#locationCollapseTwo"
                      aria-expanded="false"
                      aria-controls="locationCollapseTwo"
                    >
                      <span>Care este programul de lucru al clinicii?</span>
                    </button>
                  </h2>
                  <div
                    id="locationCollapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="locationHeadingTwo"
                    data-bs-parent="#accordionLocation"
                  >
                    <div className="accordion-body">
                      <p>Programul nostru de funcționare este:</p>
                      <ul className="faq-list">
                        <li>
                          <strong>Luni - Vineri:</strong> 09:00 - 18:00
                        </li>
                        <li>
                          <strong>Sâmbătă:</strong> 09:00 - 14:00
                        </li>
                        <li>
                          <strong>Duminică:</strong> Închis
                        </li>
                      </ul>
                      <p>
                        Pentru programări urgente în afara acestui program, vă
                        rugăm să ne contactați telefonic.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="faq-category" id="services">
              <h3 className="faq-category-title">
                <FontAwesomeIcon icon={faLungs} /> Servicii medicale
              </h3>
              <div className="accordion" id="accordionServices">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="servicesHeadingOne">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#servicesCollapseOne"
                      aria-expanded="false"
                      aria-controls="servicesCollapseOne"
                    >
                      <span>Ce este spirometria și când este recomandată?</span>
                    </button>
                  </h2>
                  <div
                    id="servicesCollapseOne"
                    className="accordion-collapse collapse"
                    aria-labelledby="servicesHeadingOne"
                    data-bs-parent="#accordionServices"
                  >
                    <div className="accordion-body">
                      <p>
                        Spirometria este un test care măsoară funcția
                        plămânilor, evaluând capacitatea și eficiența
                        respiratorie. Este recomandată în următoarele situații:
                      </p>
                      <ul className="faq-list">
                        <li>
                          Diagnosticarea astmului sau BPOC (bronhopneumopatie
                          obstructivă cronică)
                        </li>
                        <li>
                          Monitorizarea evoluției bolilor pulmonare cronice
                        </li>
                        <li>
                          Evaluarea eficacității tratamentului pentru boli
                          respiratorii
                        </li>
                        <li>
                          Screening pentru persoanele cu factori de risc
                          (fumători, expunere profesională la noxe)
                        </li>
                        <li>Evaluare pre-operatorie</li>
                      </ul>
                      <p>
                        Testul este nedureros și durează aproximativ 15-30 de
                        minute.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="servicesHeadingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#servicesCollapseTwo"
                      aria-expanded="false"
                      aria-controls="servicesCollapseTwo"
                    >
                      <span>
                        Ce pregătire este necesară pentru o consultație
                        pneumologică?
                      </span>
                    </button>
                  </h2>
                  <div
                    id="servicesCollapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="servicesHeadingTwo"
                    data-bs-parent="#accordionServices"
                  >
                    <div className="accordion-body">
                      <p>
                        Pentru o consultație pneumologică optimă, vă recomandăm:
                      </p>
                      <ul className="faq-list">
                        <li>
                          Aduceți toate rezultatele analizelor și
                          investigațiilor anterioare
                        </li>
                        <li>
                          Aduceți lista completă a medicamentelor pe care le
                          luați în prezent
                        </li>
                        <li>
                          Aduceți radiografiile sau CT-urile pulmonare efectuate
                          anterior
                        </li>
                        <li>
                          Evitați fumatul cu cel puțin 2 ore înainte de
                          consultație
                        </li>
                        <li>
                          Purtați haine comode pentru a facilita examinarea
                          toracelui
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="faq-category" id="appointments">
              <h3 className="faq-category-title">
                <FontAwesomeIcon icon={faClock} /> Programări
              </h3>
              <div className="accordion" id="accordionAppointments">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="appointmentsHeadingOne">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#appointmentsCollapseOne"
                      aria-expanded="false"
                      aria-controls="appointmentsCollapseOne"
                    >
                      <span>Cum pot face o programare?</span>
                    </button>
                  </h2>
                  <div
                    id="appointmentsCollapseOne"
                    className="accordion-collapse collapse"
                    aria-labelledby="appointmentsHeadingOne"
                    data-bs-parent="#accordionAppointments"
                  >
                    <div className="accordion-body">
                      <p>Puteți face o programare în mai multe moduri:</p>
                      <ul className="faq-list">
                        <li>
                          Online prin secțiunea "Programare" a site-ului nostru
                        </li>
                        <li>
                          Telefonic la numerele: 0725 596 895 sau 0724 284 595
                        </li>
                        <li>Direct la recepția clinicii</li>
                      </ul>
                      <p>
                        Pentru urgențe, vă rugăm să specificați acest lucru când
                        contactați clinica noastră.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="appointmentsHeadingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#appointmentsCollapseTwo"
                      aria-expanded="false"
                      aria-controls="appointmentsCollapseTwo"
                    >
                      <span>Pot anula sau reprograma o consultație?</span>
                    </button>
                  </h2>
                  <div
                    id="appointmentsCollapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="appointmentsHeadingTwo"
                    data-bs-parent="#accordionAppointments"
                  >
                    <div className="accordion-body">
                      <p>
                        Da, puteți anula sau reprograma o consultație
                        contactându-ne telefonic cu cel puțin 24 de ore înainte
                        de ora programată. Acest lucru ne permite să oferim
                        intervalul orar altor pacienți care au nevoie de
                        consultație.
                      </p>
                      <p>
                        În cazul unei urgențe care vă împiedică să ajungeți la
                        programare, vă rugăm să ne anunțați cât mai curând
                        posibil.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="faq-contact-section text-center mt-5">
            <h3>Întrebarea dvs. nu se regăsește mai sus?</h3>
            <p className="lead">
              Nu ezitați să ne contactați direct pentru orice alte întrebări
            </p>
            <div className="faq-contact-info">
              <div className="faq-phone-numbers">
                <FontAwesomeIcon icon={faPhone} className="me-2 text-primary" />
                <a href="tel:0725596895" className="me-3">
                  0725 596 895
                </a>
                <a href="tel:0724284595">0724 284 595</a>
              </div>
              <div className="mt-3">
                <a href="/contact" className="btn btn-primary mt-2">
                  Contactați-ne
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Faq;
